// @flow
import React, { PureComponent } from "react";
import RawChart from "../RawChart";

export default class BarChart extends PureComponent {
  render() {
    return <RawChart type="bar" {...this.props} />;
  }
}
